export default __webpack_public_path__ + "static/media/screen4.796cc123.png";